import {UltyDropdown} from '@ulty/ulty-ui';
import {useTranslation} from 'react-i18next';
import useFilters from '../useFilters';
import {useEffect} from 'react';
import { getMerchantsOfCompany, getPointOfSalesInScope } from '../../../../services/Company/Company.service'
import useUser from '../../UserProvider/useUser';
import { isProviderACompany } from '../../../../services/Provider/Provider.service'
import { useQuery } from '@tanstack/react-query'

const PosFilter = ({ clearable, multiple = false }) => {
    const [t] = useTranslation();
    const { user } = useUser();
    const { filters, setFilters } = useFilters();

    const { data: pointOfSales, isLoading, isSuccess } = useQuery({
        queryKey: ['pointofsales'],
        queryFn: ({ signal }) => {
            if (user.isLoggedInOwnScope) {
                return getPointOfSalesInScope(user.providers)
            }

            return getMerchantsOfCompany(
              isProviderACompany(user.provider) ?
                user.provider.object.id :
                user.provider.object.company.id,
              signal)
        },
        select: (data) => data.sort((a, b) => a.name.localeCompare(b.name)),
    })

    useEffect(() => {
        if (isSuccess && pointOfSales.length > 0 && filters.merchantId) {
            const newFilters = { ...filters, merchantId: filters.merchantId, brandIds: [] };
            setFilters(newFilters);
        }
    }, [isSuccess])

    const handleSelectedMerchantChange = (selectedMerchantId) => {
        const newFilters = {
            ...filters,
            posIds: selectedMerchantId,
            merchantId: selectedMerchantId,
            brandIds: []
        };

        setFilters(newFilters);
    }

    return (
        <UltyDropdown
            label={`${t('global.merchants')}`}
            options={(pointOfSales || []).map(item => ({
                text: item.name,
                key: item.id,
                value: item.id
            }))}
            loading={isLoading}
            multiple={multiple}
            clearable={clearable}
            search
            value={filters.merchantId || filters.posIds}
            onChange={(e, dp) => handleSelectedMerchantChange(dp.value)}
        />
    )
}

export default PosFilter;
